import { AcadlyPreferences, DialogTypes } from '../types';
import { PREFERENCES_LOCAL_STORAGE_KEY } from './constants';

export function setSkipIntroduction(key: DialogTypes, value: boolean) {
  const preferences: AcadlyPreferences = JSON.parse(
    localStorage.getItem(PREFERENCES_LOCAL_STORAGE_KEY) ?? '{}'
  );

  if (!preferences.hiddenDialogs) {
    preferences.hiddenDialogs = [];
  }

  if (!value) {
    preferences.hiddenDialogs = [...preferences.hiddenDialogs.filter((dialogName) => dialogName !== key)];
  } else {
    preferences.hiddenDialogs.push(key);
  }

  localStorage.setItem(PREFERENCES_LOCAL_STORAGE_KEY, JSON.stringify({ ...preferences }));
}

export function getIsIntroductionSkipped(key: DialogTypes): boolean {
  const preferences: AcadlyPreferences = JSON.parse(
    localStorage.getItem(PREFERENCES_LOCAL_STORAGE_KEY) ?? '{}'
  );

  return (preferences.hiddenDialogs ?? []).some((dialogName) => dialogName === key);
}

export function setPinnedCourses(courseId: string) {
  const preferences: AcadlyPreferences = JSON.parse(
    localStorage.getItem(PREFERENCES_LOCAL_STORAGE_KEY) ?? '{}'
  );

  if (!preferences.pinnedCourseIds) {
    preferences.pinnedCourseIds = [];
  }

  preferences.pinnedCourseIds = [
    ...preferences.pinnedCourseIds.filter((_courseId) => _courseId !== courseId),
    courseId,
  ];

  localStorage.setItem(PREFERENCES_LOCAL_STORAGE_KEY, JSON.stringify({ ...preferences }));
}

export function getPinnedCourses() {
  const preferences: AcadlyPreferences = JSON.parse(
    localStorage.getItem(PREFERENCES_LOCAL_STORAGE_KEY) ?? '{}'
  );

  return preferences.pinnedCourseIds ?? [];
}
